export class BookingViewModel
{
    FromCountryId:number;        
    ToCountryId:number;     
    FromPortId:number   
    ToPortId:number;
    RateRequestId:number;
    TermsAndCondition:boolean;
    OfferedRateId:number;
    ShippingLineId:number; 
    VesselsId:number; 
    VoyageId:number; 
    BookingNumber:string;
    CreatedBy:string;
    paymentdetails:PaymentDetails;
}

export class PaymentDetails{
    TransactionId :string;
    EmailId:string; 
    FullName :string;
    Status :string;
    AmountDebited:string;
    Paypalfees :string;
    AmountCredited :string;
    BookingNo :string;
    PayerID :string
    IsBookingPayment :boolean;
    CreatedDate?:Date;
    CreatedBy:string;
}